module.exports = __webpack_public_path__ + "media/25.b2f8ce90.mp3";